import { Component, Input } from "@angular/core";
import { CommonModule } from "@angular/common";
import { UIRouterModule } from "@uirouter/angular";
import { AppsService } from "app/commons/services/applications.service";

@Component({
    selector: "op-logo-selector",
    templateUrl: "./opLogoSelector.view.html",
    styleUrls: ["./opLogoSelector.style.scss"],
    imports: [CommonModule, UIRouterModule]
})

export class OpLogoSelector {

  constructor (private _apps: AppsService) {}

  private readonly _emLogoSrc = "assets/img/everymundo_logo.png";

  protected _appName: string = "";
  protected _title: string = "";
  protected _stateName: string ="";

  get currentApp() { return this._appName }
  @Input() set currentApp(value: string) {
    const app = this._apps.getApplicationSync(value);
    this._appName = app?.id ? app.id : "";
    this._title = app?.logoText ? app.logoText : "";
    this._stateName = app?.link ? app.link : "";
  };
}
